import { Box } from "@mui/material";
import { forwardRef } from "react";

const SvgColor = forwardRef(({ src, sx, ...other }: any, ref) => (
	<Box
		component="span"
		className="svg-color"
		ref={ref}
		sx={{
			width: 24,
			height: 24,
			display: "inline-block",
			bgcolor: "currentColor",
			mask: `url(${src}) no-repeat center / contain`,
			WebkitMask: `url(${src}) no-repeat center / contain`,
			...sx,
		}}
		{...other}
	/>
));

export default SvgColor;
